import React from 'react';
import { ColumnActions } from 'components/Table';
import {
  STATUS_VALUES,
  CLIENT_ORDER_STATUS_MAPPING,
  DATE_FIELD,
} from 'helper/const';
import {
  renderStandardColumn,
  renderPriceColumn,
  renderTagColumn,
  renderDateColumn,
} from 'utils/table';

const automatedOrderColumns = ({
  onView,
  onEditDraft,
  onDelete,
  canManageScheduledServices,
}) => {
  return [
    {
      title: 'Order Number/Type',
      dataIndex: 'order_number',
      render: (value, record) => {
        const orderTypeName =
          record.order_type && typeof record.order_type === 'object'
            ? record.order_type.name
            : record.order_type || '';
        const orderNumber = `Order #${record.id}`;
        return (
          <>
            <b>{orderNumber}</b>
            <br />
            {orderTypeName}
          </>
        );
      },
      width: 160,
    },
    {
      title: 'Payment Method',
      dataIndex: 'payment_method',
      render: renderStandardColumn,
      width: 160,
    },
    {
      title: 'Amount',
      dataIndex: 'total',
      render: renderPriceColumn,
      width: 100,
    },
    {
      title: 'Date Requested',
      dataIndex: 'submitted_on',
      render: value => renderDateColumn(value, DATE_FIELD.FORMAT),
      width: 150,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value, record) => {
        const canEditFromStatus =
          canManageScheduledServices && record.status === STATUS_VALUES.DRAFT;

        return renderTagColumn(
          value,
          record,
          canEditFromStatus ? () => onEditDraft(record) : undefined,
          CLIENT_ORDER_STATUS_MAPPING
        );
      },
      width: 130,
    },
    {
      title: 'Date Completed',
      dataIndex: 'completed_on',
      render: value => renderDateColumn(value, DATE_FIELD.FORMAT),
      width: 150,
    },
    {
      title: '',
      width: 30,
      render: (_value, record) => {
        const actions = [
          {
            label: 'View',
            props: {
              onClick: () => onView(record),
            },
          },
        ];

        if (canManageScheduledServices) {
          actions.push({
            label: 'Edit',
            props: {
              onClick: () => {
                if (record.status === STATUS_VALUES.DRAFT) {
                  onEditDraft(record);
                }
              },
            },
          });
        }

        if (
          canManageScheduledServices &&
          record.status === STATUS_VALUES.DRAFT
        ) {
          actions.push({
            label: 'Delete',
            props: {
              onClick: () => onDelete(record),
            },
          });
        }
        return <ColumnActions trigger={['click']} actions={actions} />;
      },
    },
  ];
};

export { automatedOrderColumns };
